import { InjectionToken } from '@angular/core';

export const LOGIN_URL: InjectionToken<string> = new InjectionToken<string>("login url")